import { rem } from 'polished'
import React, { useRef } from 'react'
import styled, { keyframes } from 'styled-components'

import useClickOutsideBox from '../hooks/useClickOutsideBox'
import SearchOrPOISummaryCard from '../SummaryCards/Search/SearchOrPOISummaryCard'

import { DesktopLayoutSizes } from 'tripPlanner/components/ItemCard/Common/utils'
import ExploreCardSkeleton from 'tripPlanner/components/Skeleton/ExploreCardSkeleton'
import { ExploreItem, ItemWithOnlyLatLng } from 'tripPlanner/types/common'
import { isExploreItem } from 'tripPlanner/utils/explore'

// Define the keyframes for the animation
const slideUp = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`

const GooglePOICardContainer = styled.div`
  position: absolute;
  z-index: 5;
  padding: ${rem(16)};
  bottom: 0;
  width: 100%;
  animation: ${slideUp} 0.2s ease-in-out;

  ${DesktopLayoutSizes} {
    padding: ${rem(24)};
  }
`

interface Props {
  selectedMarker: ExploreItem | ItemWithOnlyLatLng | undefined | null
  onDeselect: () => void
  containerRef?: React.RefObject<HTMLDivElement>
}

function GooglePOICardSingle({
  selectedMarker,
  onDeselect,
  containerRef,
}: Props) {
  // Pass this ref into the ExploreMapSummary card so that so the deselecting logic only occurs
  // when it's from the inner container (non-padding area of the card)
  const cardRef = useRef<HTMLDivElement | null>(null)

  useClickOutsideBox(cardRef, onDeselect, { excludeModalClicks: true })

  return (
    <GooglePOICardContainer ref={containerRef}>
      {selectedMarker && isExploreItem(selectedMarker) && (
        <SearchOrPOISummaryCard
          item={selectedMarker}
          ref={cardRef}
          alwaysShadow
          showCloseButton
          onClose={onDeselect}
        />
      )}
      {!(selectedMarker && isExploreItem(selectedMarker)) && (
        <ExploreCardSkeleton />
      )}
    </GooglePOICardContainer>
  )
}

export default GooglePOICardSingle
